import { useEffect, useState } from 'react';
import { useSurveyIfEnabled } from '../hooks/useSurveyIfEnabled';
import { SurveyName } from '../surveysUuidMap';
import { formulaFieldsSurveyBlockersSelector } from './blockersSelectors';
import { getFieldsSurveysBlockersFromSurvey } from './dialogBlockers';
import { FieldsSurveyDialog } from './dialogs/FieldsSurveyDialog';

const SURVEY_NAME = 'formulaFieldsSurvey' satisfies SurveyName;

type FormulaFieldsSurveyProps = {
  focused: boolean;
};

const FormulaFieldsSurvey = ({ focused }: FormulaFieldsSurveyProps) => {
  const [userEngaged, setUserEngaged] = useState(false);

  const surveyInfo = useSurveyIfEnabled({
    surveyName: SURVEY_NAME,
    userEngaged,
    blockersSelector: formulaFieldsSurveyBlockersSelector,
    getBlockersFromSurvey: getFieldsSurveysBlockersFromSurvey,
  });

  // we have sufficient engagement for survey feedback after 10s spent
  // w/ this component rendered and focused
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (focused) {
        setUserEngaged(true);
      }
    }, 10 * 1000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [focused]);

  return (
    <>
      {surveyInfo.survey && focused && (
        <FieldsSurveyDialog
          open={surveyInfo.shouldViewSurvey}
          survey={surveyInfo.survey}
          viewBlockers={surveyInfo.viewBlockers}
          surveyName={SURVEY_NAME}
        />
      )}
    </>
  );
};

export { FormulaFieldsSurvey };
